import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=2d03df92&scoped=true&"
import script from "./ShareButton.vue?vue&type=script&lang=js&"
export * from "./ShareButton.vue?vue&type=script&lang=js&"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=2d03df92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d03df92",
  null
  
)

export default component.exports